import { lazy } from "react";
import { loadDateRangeLib } from "@/extension/utils/lazy-lib";

/**
 * React.lazy boundary over the react-date-range picker.
 *
 * The lib (DateRange component) is fetched on first render from the
 * lazy/date-range.js WAR bundle, which shares app.js's React via the
 * __BT_REACT__ bridge (see src/extension/utils/lazy-lib.ts). Every prop is
 * forwarded straight through to <DateRange>.
 *
 * react-date-range's CSS (styles.css + theme/default.css) is link-injected via
 * each manifest's content_scripts.css (extension) and imported in bt-timeline.tsx
 * for the website build — it is NOT part of the lazy JS bundle.
 *
 * Must be rendered inside a <Suspense> boundary (bt-timeline.tsx provides one).
 */
const LazyDateRange = lazy(async () => {
  const { DateRange } = await loadDateRangeLib();
  // Wrap in a props:any forwarder (mirrors lazy-dnd-calendar) so the React.lazy
  // component accepts arbitrary DateRange props — DateRange itself is typed `any`.
  const Wrapped = (props: any) => <DateRange {...props} />;
  return { default: Wrapped };
});

export default LazyDateRange;
